import { Component, OnInit, HostListener } from '@angular/core';
import { ModalService, MODAL } from '../../services/modal.service';
import { VendorService } from '../../services/vendor.service';
import { CustomerService } from '../../services/customer.service';
import { Key } from 'ts-keycode-enum';
import { environment } from 'src/environments/environment';
import { SearchInput } from 'src/app/services/kingfisher/search-input';
import { HbmApiService } from 'src/app/services/hbm/hbm-api.service';
import { Customer } from 'src/app/services/kingfisher/customer';
import { StatusCodes } from 'http-status-codes';
import { SearchPatternTypeEnum } from 'src/app/enum/kitchen/portal/project/search-pattern-type.enum';
import { logError } from 'src/app/services/helpers/sentry.helper';

@Component({
  selector: 'ng-casto-old-search-customer',
  templateUrl: './old-search-customer.component.html',
})
export class OldSearchCustomerComponent implements OnInit {
  public inputs: SearchInput;
  public isLoading: boolean;
  public searchResults: Customer[];
  public requestError: string;

  constructor(
    public modal: ModalService,
    public vendor: VendorService,
    public customer: CustomerService,
    private readonly hbmService: HbmApiService
  ) {
    this.inputs = {
      email: '',
      lastname: '',
      firstname: '',
      zipcode: '',
      customerId: '',
      phone: '',
      fidelityId: '',
    };
  }

  ngOnInit(): void {
    this.initDefaultValue();
    if (environment.configurators2d.global.debug.fakeCustomer === true) {
      this.selectCustomer(environment.configurators2d.global.debug.data.customer);
    }
  }

  get defaultInput() {
    return this.modal.currentDatas.defaultValue;
  }

  initDefaultValue() {
    if (!this.defaultInput) {
      return;
    }

    let value = this.defaultInput.value;

    switch (this.defaultInput.searchPatternType) {
      case SearchPatternTypeEnum.ID:
        this.inputs.customerId = value;
        break;
      case SearchPatternTypeEnum.EMAIL:
        this.inputs.email = value;
        break;
      case SearchPatternTypeEnum.FIDELITY:
        this.inputs.fidelityId = value;
        break;
      case SearchPatternTypeEnum.NAME:
        this.inputs.lastname = value;
        break;
      case SearchPatternTypeEnum.PHONE_NUMBER:
        this.inputs.phone = value;
        break;
      case SearchPatternTypeEnum.POSTAL_CODE:
        this.inputs.zipcode = value;
        break;
      case SearchPatternTypeEnum.UNIDENTIFIED:
        this.inputs.lastname = value;
        break;
      default:
        logError(
          `Erreur lors de l'initialisation de la valeur par défaut. Type : ${this.defaultInput.searchPatternType}`
        );
    }
  }

  async search() {
    this.requestError = '';
    this.isLoading = true;

    try {
      this.searchResults = await this.vendor.oldSearchCustomers(this.inputs);
      this.requestError = this.searchResults.length > 0 ? '' : 'Aucun résultat';
    } catch (error) {
      logError(error);
      if (error.status >= StatusCodes.INTERNAL_SERVER_ERROR) {
        alert('ATG : ERROR 5xx - SERVER_ERROR');
      }
      this.searchResults = [];
      this.requestError = error.description;
    } finally {
      this.isLoading = false;
    }
  }

  async selectCustomer(customer: Customer) {
    await this.hbmService.acquireTokenWS(customer.id, 'token');
    this.customer.userDatas = customer;
    if (this.modal.currentDatas?.onCustomerSelect) {
      this.modal.currentDatas.onCustomerSelect();
    }
  }

  close() {
    this.modal.close();
  }

  addNewCustomer() {
    this.modal.currentId = MODAL.REGISTER_CUSTOMER;
    this.modal.currentDatas.loginCallBack = () => {
      this.modal.currentDatas.onCustomerSelect();
    };
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.which === Key.Enter) {
      this.search();
    }
  }
}
